/** Static COS builds use a separate HTTPS/WSS bridge; server builds stay same-origin. */
export function websocketProxyUrl(path: string): string {
  const base = import.meta.env.VITE_WS_PROXY_BASE_URL || location.origin.replace(/^http/, "ws");
  return `${base.replace(/\/+$/, "")}${path}`;
}

export function imageProxyUrl(path: string): string {
  const base = import.meta.env.VITE_IMAGE_PROXY_BASE_URL || "";
  return `${base.replace(/\/+$/, "")}${path}`;
}
